export enum SearchParams {
    NATIVE = 'native'
}
